export default __webpack_public_path__ + "static/nexgen-algorithm-and-data-structure-9ce18c8026268877dc5a75ead04907cf.webp";